import React from "react";
import cn from "classnames";

const DataMap = ({ data }) => {
  return (
    <svg viewBox="0 0 1780 720">
      <g>
        {data.map(
          ({
            id,
            path,
            center,
            end,
            endGMO,
            yearEnded,
            yearEndedWithoutGMO,
            updatesWithGMO,
            index,
            indexGMO,
          }) => (
            <g
              className={cn("country-with-malaria", {
                "country-with-malaria--withGMO": updatesWithGMO,
              })}
              data-yearEnded={yearEnded}
              data-yearEndedGMO={yearEndedWithoutGMO}
              data-index={index}
              data-indexGMO={indexGMO}
              data-endX={end.x}
              data-endY={end.y}
              data-endGMOX={endGMO.x}
              data-endGMOY={endGMO.y}
              data-centerX={center.x}
              data-centerY={center.y}
            >
              <path
                key={`path-${id}`}
                d={path}
                fill={"#FFAF3E"}
                stroke="#1A1C35"
                strokeWidth={1}
                data-centerX={center.x}
                data-centerY={center.y}
              />
              <circle cx={center.x} cy={center.y} r={5} fill={"#FFAF3E"} />
            </g>
          )
        )}
      </g>
    </svg>
  );
};

export default DataMap;



// WEBPACK FOOTER //
// ./src/components/map/datamap.js